<template>
  <div class="app-main-content">
    <h1>Page not found</h1>
    <p>
      Back to <router-link :to="{ name: PAGES.home }">Reservations home</router-link>.
    </p>
    <RiDmvHome />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import RiDmvHome from "@/components/RiDmvHome.vue"; // Added .vue extension
import { useHead } from '@unhead/vue';
import appConfig from '@/app.config'

// Vuex store
const store = useStore();

// Computed prop
const PAGES = computed(() => store.state.user.PAGES);

// Use usehead to manage the page meta
useHead({
  title: `${appConfig.shortName} Page Not Found`,
  meta: [
    {
      name: 'description',
      content: 'The page you are looking for does not exist.'
    }
  ]
});
</script>
